import { Component } from '@angular/core';
import { GridState, LoaderService, MessageService, NamedEntity, ValidationResultService } from '@shared';
import { GlobalEventsService, ConceptService } from '@shared-data';

@Component({
  selector: 'app-concept-selector',
  templateUrl: './concept-selector.component.html',
  styleUrl: './concept-selector.component.scss'
})
export class ConceptSelectorComponent {
  concepts: NamedEntity[] = [];
  selectedConcept!: NamedEntity;


  constructor(
    private globalEventsService: GlobalEventsService,
    private messageService: MessageService,
    private loaderService: LoaderService,
    private validationErrorService: ValidationResultService,
    private conceptService: ConceptService,
  ) {}

  ngOnInit() {
    this.fetchConcepts();
  }

  fetchConcepts() {
    this.loaderService.show();
    this.conceptService.getAllConcepts({} as GridState).subscribe({
      next: (concepts) => {

        this.concepts = concepts.data as NamedEntity[];

        const newSelectedConcept = this.concepts.find(
          (concept) => concept.id === this.selectedConcept?.id,
        );
        this.onConceptSelected(newSelectedConcept || this.concepts[0]);

        this.loaderService.hide();
      },
      error: (error) => {
        this.messageService.error(error);
        var validationError = error?.error;
        if (validationError) {
          this.validationErrorService.show(validationError);
        }
        this.loaderService.hide();
      },
    });
  }

  onConceptSelected(event: any) {
    if (event != null) {
      let concept = event as NamedEntity;
      this.selectedConcept = event;

      this.globalEventsService.updateSelectedConcept(concept);
    }
  }
}
